/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M3.25 9.25A.75.75 0 0 1 4 8.5h8.5a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75ZM4 12.25a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5H4ZM20.8075 15.7517a.75.75 0 1 0-1.115-1.0034l-3.117 3.4633-1.8454-1.5378a.75.75 0 0 0-.9602 1.1524l2.9546 2.4622 4.083-4.5367Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M0 3.75C0 1.679 1.679 0 3.75 0h15c2.0711 0 3.75 1.679 3.75 3.75v9.257c.9381 1.1593 1.5 2.6355 1.5 4.243 0 3.7279-3.0221 6.75-6.75 6.75-2.5497 0-4.7692-1.4137-5.9175-3.5H3.75C1.679 20.5 0 18.8211 0 16.75v-13Zm21 2.5v5.3867c-1.0726-.718-2.3624-1.1367-3.75-1.1367-3.7279 0-6.75 3.0221-6.75 6.75 0 .6052.0797 1.1919.2291 1.75H3.75c-1.2426 0-2.25-1.0074-2.25-2.25V6.25H21Zm0-1.5v-1c0-1.2426-1.0074-2.25-2.25-2.25h-15C2.5074 1.5 1.5 2.5074 1.5 3.75v1H21Zm-9 12.5c0-2.8995 2.3505-5.25 5.25-5.25s5.25 2.3505 5.25 5.25-2.3505 5.25-5.25 5.25S12 20.1495 12 17.25Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'MenuResourceManifest'
);
